import React, { useEffect, useImperativeHandle, useState } from "react";
import { Modal } from "antd";
import styles from "./index.module.scss";
import Header from "./components/Header";
import Aside from "./components/Aside";
import Footer from "./components/Footer";
import { ModalProps } from "antd/es/modal";
import Viewer from "./components/Viewer";
import AsideLink from "./components/Aside/components/AsideLink";
import { ListProps } from "./servers";
import useDeviceType from "../../Utils/useDeviceType";

interface CourseWareModalProps extends ModalProps {
    onOk?: () => void;
    onCancel?: () => void;
    FILETYPE_LIST: Record<string, string[]>;
}

interface DataModalInstance {
    setPayload: (payload: any) => void;
    setList: (list: ListProps[]) => void;
}

const PreviewSourceModal = React.forwardRef<
    DataModalInstance,
    CourseWareModalProps
>(({ FILETYPE_LIST, onOk, onCancel, ...props }, ref) => {
    const [showAside, setShowAside] = useState(true);
    const [activeIndex, setActiveIndex] = useState(0);
    const [defaultId, setDefaultId] = useState(-1);
    const [list, setList] = useState<ListProps[]>([]);
    const { isPC, isMobile } = useDeviceType();

    useImperativeHandle(ref, () => ({
        setPayload: payload => {
            setDefaultId(payload);
        },
        setList: list => {
            setList(list);
        }
    }));

    useEffect(() => {
        const index = list.findIndex(item => item.id === defaultId);
        if (index !== -1) setActiveIndex(index);
    }, [defaultId]);

    return (
        <Modal
            title={null}
            footer={null}
            className={styles.root}
            closable={false}
            centered
            {...props}>
            <Header onCancel={onCancel} />

            <div className={styles.body}>
                {isPC && (
                    <Aside
                        visible={showAside}
                        onToggle={() => setShowAside(!showAside)}>
                        {list.map((item, index) => (
                            <AsideLink
                                key={item.id}
                                active={index === activeIndex}
                                onClick={() => setActiveIndex(index)}
                                item={item}
                            />
                        ))}
                    </Aside>
                )}

                <div className={styles.container}>
                    <div className={styles.main}>
                        {list.length !== 0 && (
                            <Viewer
                                key={activeIndex}
                                FILETYPE_LIST={FILETYPE_LIST}
                                data={list[activeIndex]}
                            />
                        )}
                    </div>

                    <Footer
                        activeIndex={activeIndex}
                        setActiveIndex={setActiveIndex}
                        listLength={list.length}
                    />
                </div>
            </div>
        </Modal>
    );
});
export default PreviewSourceModal;
